"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Ref } from "vue-property-decorator";
import PaymentNewVdFilterDialog from "./dialog/PaymentNewVdFilterDialog.vue";
import { CategorieIds, PaymentController } from "@/service/newProdect";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
const chat_gpt_tag = require("../../../assets/img/tag-icons/new_tag_chat_gpt.png");
let PaymentNewCateGory = class extends Vue {
  constructor() {
    super(...arguments);
    this.name = "PaymentNewCateGory";
    this.defaultSelect = null;
    this.dialog = new UiDialogController();
    this.tip_dialog = null;
    this.chat_gpt_tag = chat_gpt_tag;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  clearFilter() {
    return __async(this, null, function* () {
      this.$emit("showLoading", false);
      this._options.selected.filterName = "";
      this._options.selected.searchParams = {};
      yield this._options.search();
      this.$emit("showLoading", true);
    });
  }
  openFilter() {
    return __async(this, null, function* () {
      this._paymentNewVdFilterDialog.show();
    });
  }
  historyChoose() {
    return __async(this, null, function* () {
      this.$emit("showLoading", false);
      this._options.selected.filterName = "";
      this._options.selected.searchParams = {
        type: "history"
      };
      try {
        let response = yield API.get(
          `api://base.auth/api/v8/payment/recomment/ipregion`,
          {
            params: {
              type: "history"
            }
          }
        );
        const categorieids = new CategorieIds();
        categorieids.types = response.data.type.id || "";
        categorieids.regions = response.data.region.id || "";
        categorieids.areas = response.data.area.id || "";
        categorieids.remotes = response.data.remote.id || "";
        categorieids.models = response.data.model.id || "";
        categorieids.categorys = response.data.service_provide.id || "";
        console.dir(categorieids);
        yield this._options.selectCategorieByIds(categorieids);
        this.$emit("calculation", true);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
      this.$emit("showLoading", true);
    });
  }
  // recommandRegion() {
  //   this.$router.push("/welcome");
  // }
  changeTopGroup(data) {
    return __async(this, null, function* () {
      if (data.tips) {
        this.tip_dialog = data.tips;
        this.dialog.visible = true;
      }
      yield this._options.changeRegions(data.id);
      this.$emit("changetopgroup");
      this.$emit("calculation", true);
    });
  }
  closeDialog() {
    this.dialog.visible = false;
    this.tip_dialog = null;
  }
  changeRegion(data) {
    return __async(this, null, function* () {
      if (data.tips) {
        this.tip_dialog = data.tips;
        this.dialog.visible = true;
      }
      yield this._options.changeAreas(data.id);
      this.$emit("calculation", true);
    });
  }
  changeArea(data) {
    return __async(this, null, function* () {
      if (data.tips) {
        this.tip_dialog = data.tips;
        this.dialog.visible = true;
      }
      yield this._options.changeRemotes(data.id);
      this.$emit("calculation", true);
    });
  }
  choose(data) {
    return __async(this, null, function* () {
      this.$emit("showLoading", false);
      this._options.selected.filterName = data.name;
      this._options.selected.searchParams = {
        platform_id: data.guid
      };
      yield this._options.search();
      this.$emit("showLoading", true);
    });
  }
};
__decorateClass([
  Ref("payment-new-vd-filter-dialog")
], PaymentNewCateGory.prototype, "_paymentNewVdFilterDialog", 2);
__decorateClass([
  PropSync("paymentStyle", {
    default: function() {
      return "";
    }
  })
], PaymentNewCateGory.prototype, "_payment_style", 2);
__decorateClass([
  PropSync("options", {
    default: function() {
      return new PaymentController();
    }
  })
], PaymentNewCateGory.prototype, "_options", 2);
PaymentNewCateGory = __decorateClass([
  Component({
    components: {
      PaymentNewVdFilterDialog,
      UiDialog
    }
  })
], PaymentNewCateGory);
export {
  PaymentNewCateGory as default
};
